// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._19bvutpp{padding-left:var(--ds-space-150,9pt)}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._1wpz1h6o{align-self:center}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._syazpbcx{color:var(--ds-text-accent-red,#ae2a19)}\n._u5f3utpp{padding-right:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
